/**
 * Created by Miguel on 23/05/2017
 */
import { Component   } from '@angular/core';
import {UserService} from "../../../services/user.service";
import { AppDataService }  from '../../../services/app-data.service';
import { CompanyService }  from '../../../services/company.service';
import {ContainerModal} from "./container-modal";
import { ItemBean } from '../../../beansts/item.bean';
import { WalletService } from '../../../services';
import { TranslationService } from '../../../services/translation.service';

declare var $ : any;
declare var Swal: any

@Component({
    selector : 'paint-container',
    templateUrl:'paint-container.html',
    providers  : [],  
})
export class PaintContainerModal extends ContainerModal {

  public containerName='Container';
  public ctx;
  public canvas;
  public ctx2;
  public canvas2;


  public color

  public bufferImage;
  public bufferName;



    public ngOnInit() : any {
      $(".slider, .innerslider").slider();
    }

    public drawEquipedItem(){
      if (!this._appData.images){
        this._appData.images={}
      }
      if (! this.canvas){
        this.canvas = $("#spritesheet").get(0);
        this.ctx = this.canvas.getContext("2d"); 
      }
      this.saveNewStyle();

    }
    
    public changeColor(){
//      <input type="color" id="colorPicker" (change)="changeColor()" value="#ffffff">
  //    <input type="range" id="opacityPicker" (change)="changeColor()" min="0" max="100" value="50">
      let color=$('#colorPicker').val()
      let range=$('#opacityPicker').val()
      let rgb=this.hexToRgb(color);
      this.color='rgb('+rgb.r+','+rgb.g+','+rgb.b+','+range/100+')'
      this.redraw();
    }
    private hexToRgb(hex) {
      var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
      } : null;
    }
    public saveColor(){
      Swal.fire({
        title:'Salvar cor',
        text:'Você deseja mudar a cor deste item?',
        confirmButtonText: "Sim",
        cancelButtonText:"Cancelar",
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false, 
        }).then((result) => {
          if (result.dismiss=='backdrop') {}
          else if (result.dismiss=='cancel'){}
          else{
              this.saveNewStyle();
            }
        })
    }
    public change() {
      this.color=this._appData.selectedItem.color;
      if (!this._appData.selectedItem.thumbnailSrc) this._appData.selectedItem.thumbnailSrc=this._appData.selectedItem.thumbnail
      let img2 = this.getImage(this._appData.selectedItem.src)
      let img = this.getImage(this._appData.selectedItem.thumbnailSrc)
      //equip on close if needed
      $('#paintModal').on('hidden.bs.modal',  () =>{
        // do something…     
        this._appData.selectedItem=null;
        $('#containerModal').modal("show")
        $('#containerModalClick').click()

      })
    }
    constructor( _appData : AppDataService, _companyService : CompanyService, _auth : UserService, _wallet :WalletService, translate: TranslationService) {
      super(_appData,translate,_companyService,_wallet,_auth);
    }


    ///////////////////ALL ABOUT DRAWING//////////////
    public redraw() {
      let canvas
      let ctx
      let mergedImages=[];
      if (!this.ctx){
        this.canvas = $("#drawspritesheet").get(0);
        this.ctx = this.canvas.getContext("2d"); 

        this.canvas2 = $("#drawspritesheetView").get(0);
        this.ctx2 = this.canvas2.getContext("2d"); 

      }
      ctx=this.ctx;
      canvas=this.canvas;
      let ctx2=this.ctx2;
      let canvas2=this.canvas2;

      // start over
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx2.clearRect(0, 0, canvas2.width, canvas2.height);

      //body
      let img = this.getImage(this._appData.selectedItem.src)
      if (!this._appData.selectedItem.thumbnailSrc) this._appData.selectedItem.thumbnailSrc=this._appData.selectedItem.thumbnail
      let img2= this.getImage(this._appData.selectedItem.thumbnailSrc)

      this.drawImage(ctx, img,this.color)
      this.drawImage(ctx2, img2,this.color)
         
      return true;

  }
  public getImage(imgRef) {
      if (this._appData.images[imgRef])
          return this._appData.images[imgRef];
      else {
          // Load image if not in cache
          var img = new Image();
          img.src = imgRef;
          img.onload = ()=>{
            this.redraw();
          }
          this._appData.images[imgRef] = img;
          return img;
      }
  }
  public getImageNoDraw(imgRef) {
    if (this._appData.images[imgRef])
        return this._appData.images[imgRef];
    else {
        // Load image if not in cache
        var img = new Image();
        img.src = imgRef;
        img.onload = ()=>{
          this._appData.images[imgRef].loaded=true;
        }
        this._appData.images[imgRef] = img;
        return img;
    }
}


  // Do not stop running all javascript if image not available
public drawImage(ctx, img,color) {
    try {
        img.setAttribute('crossorigin', 'anonymous');

        let bcanvas = $("#buffer").get(0);
        bcanvas.style.visibility='hidden'
        bcanvas.width=1008
        bcanvas.height=1360
        let bctx = bcanvas.getContext("2d"); 
        bctx.globalCompositeOperation='source-over';     
        bctx.drawImage(img, 0, 0);
        bctx.globalCompositeOperation='source-atop';
        bctx.fillStyle = color;
        bctx.fillRect(0,0,img.width,img.height);
    
    
        ctx.globalCompositeOperation='source-over';     
        ctx.drawImage(bcanvas, 0, 0,img.width,img.height,0,0,img.width,img.height);

      } catch(err) {
        console.error("Error: could not find " + img.src+ err);
    }
  }
  public saveNewStyle(){
      //update user on game and on database


        //thumbnail
        var dataurl = this.canvas2.toDataURL("image/png")
        let filename: string = this._appData.selectedItem.objectId+'_thumbnail.png';
        var arr = dataurl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]), 
        n = bstr.length, 
        u8arr = new Uint8Array(n);       
        while(n--){
            u8arr[n] = bstr.charCodeAt(n);
        }
        let pngFile=new File([u8arr], filename, {type:"image/png"});
        this._auth.uploadToFirebase(pngFile, filename, 'userprofile/'+this._appData.instagramUser.uid+'/customItems/'+this._appData.selectedItem.objectId).subscribe(snapshot =>{
          snapshot.ref.getDownloadURL().then(url => {
            this._appData.selectedItem.thumbnail=url;
            this._appData.selectedItem.color=this.color;
            this._companyService.getUserContainerRef().doc(this._appData.selectedItem.objectId.toString()).set(this._appData.selectedItem.toDB())   
            for (let i=0; i< this._appData.userEventContainer.length;i++){
              let it=this._appData.userEventContainer[i];
              if (it.objectId==this._appData.selectedItem.objectId){
                this._appData.userEventContainer[i]=this._appData.selectedItem;
              }
            }
            $('#paintModal').modal('hide')       
            this._appData.selectedItem=null;
            $('#containerModal').modal("show")
            $('#containerModalClick').clickmodal()
          })   
        });

    }
    public sendIframeMessage(messageKind,frame){
      var iframe = document.getElementById(frame);
      if (iframe == null) return;
      var iWindow = (<HTMLIFrameElement>iframe).contentWindow;
      iWindow.postMessage(messageKind, "*");
    }

}


// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/components/+gameevent/container/paint-container.ts